
export default {

    getMinMaxValidationObject: (min, max, trigger, long = true) => {
        return {
            min: min,
            max: max,
            message: long ? 'Mindestlänge von ' + min + ' und Maximallänge von ' + max + ' Zeichen' : 'Min '+ min + ', max '+max + ' Zeichen',
            trigger: trigger
        };
    },

    getPhoneNumberValidationObject: (trigger) => {
        return {
            pattern: (new RegExp('^[+]?([0-9 ])+$')),//phone number optionally starting with "+" follwoed by infinite amount of numbers and whitespaces
            message: 'Ungültige Telefonnummer',
            trigger: trigger
        };
    },

    getEmailValidationObject: (trigger) => {
        return {
            type: 'email',
            message: 'Bitte eine gültige E-Mail-Adresse eingeben',
            trigger: trigger
        }
    },

    getCustomAlphaValidationObject: (trigger) => {
        return {
            pattern: (new RegExp( '^[a-zA-Z- \u00C0-\u017F]+$')),//a-z, A-Z, dash, whitespace, À-ſ (=European Latin Extended-A)
            message: 'Bitte keine Sonderzeichen einfügen',
            trigger: trigger
        };
    },

    getNumberValidationObject: (min, max, trigger) => {
        return {
            pattern: (new RegExp("^[0-9']{" + min + "," + max + "}?$")),
            message: 'Es muss eine Zahl mit Mindestlänge von ' + min + ' und Maximallänge von ' + max + ' Stellen sein',
            trigger: trigger
        };
    },

  /*  getFractionValidationObject: (trigger) => {
        return {
            pattern: (new RegExp('[1-9][0-9]*\/[1-9][0-9]*')),
            message: 'Bitte einen Bruch eingeben',
            trigger: trigger
        };
    },

    getZipCodeValidationObject: (trigger) => {
        return {
            pattern: (new RegExp('^[a-zA-Z0-9-\\s]{4,10}?$')),//numbers 0-9, letters , dashes - and whitespaces \s within 4 to 10 total digits
            message: 'Ungültiger ZIP-Code',
            trigger: trigger
        };
    },*/

    getRequiredValidationObject: (trigger) => {
        return {required: true, message: 'Bitte dieses Feld ausfüllen', trigger: trigger};
    },

    getContainNumberValidationObject: (trigger) => {
        return {
            // pattern: (new RegExp("^(?=.*\d).{1,}$")),
            pattern: (new RegExp("(?=^.*[0-9].*$)")),
            message: 'Es muss min. eine Zahl enthalten sein',
            trigger: trigger
        }
    },

    getContainUpperValidationObject: (trigger) => {
        return {
            // pattern: (new RegExp("^[A-Z]+$")),
            pattern: (new RegExp("(?=^.*[A-Z].*$)")),
            message: 'Es muss min. ein Grossbuchstabe enthalten sein',
            trigger: trigger
        }
    },

    getMinLengthValidationObject: (min, trigger) => {
        return {
            pattern: (new RegExp("^.{" + min + ",}$")),
            message: 'Die Mindestlänge beträgt '+ min +' Zeichen',
            trigger: trigger
        }
    },

    getContainLowerValidationObject: (trigger) => {
        return {
            pattern: (new RegExp("(?=^.*[a-z].*$)")),
            message: 'Es muss min. ein Kleinbuchstabe enthalten sein',
            trigger: trigger
        }
    },

    getContainSymbolValidationObject: (trigger) => {
        return {
            // lol for \ in regex \\\\ two escaped backslashes have to be used
            pattern: (new RegExp("(?=^.*[!@#$%^&*()_+=\[{\\]};:<>|.\/?\\\\,-].*$)")),
            message: 'Es muss min. ein Symbol enthalten sein z.B. !@#$%^&*()_+=[{]};:<>|./?,-',
            trigger: trigger
        }
    },

    // getRequiredNonEmptyStringObject: (trigger) => {
    //     return {
    //         required: true, pattern: (new RegExp('.*[^ ].*?')), message: "Bitte dieses Feld ausfüllen", trigger: trigger
    //     }
    // }
}